"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentTournament = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var next_intl_1 = require("next-intl");
var useCurrentTournament = function (_a) {
    var slug = _a.slug, status = _a.status;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var lang = (0, next_intl_1.useLocale)();
    var _b = (0, useQuery_1.useQuery)({
        path: keys_1.TOURNAMENTS_CURRENT,
        payload: { status: status, slug: slug, currency: currentCurrency, lang: lang },
        revalidateOnMount: true,
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, mutate = _b.mutate, isValidating = _b.isValidating;
    return (0, react_1.useMemo)(function () {
        var _a;
        return ({
            data: ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.current) || null,
            isLoading: isLoading,
            isValidating: isValidating,
            error: error,
            mutate: mutate,
        });
    }, [mutate, data, isLoading, error, isValidating]);
};
exports.useCurrentTournament = useCurrentTournament;
